import { useEffect } from "react"

import { AuditOutlined } from "@ant-design/icons"
import { Button, Spin } from "antd"

import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"
import { Table } from "@/components/_Shared/Table"
import { Resource, Scope } from "@/constants/permission"

import { financeColumns } from "./FinanceColumns"
import { useFinanceFilters } from "./FinanceFilters"

import { useFinanceQuery } from "@/hook/useFinanceQuery"
import { useMessage } from "@/hook/useMessage"
import { usePermission } from "@/hook/usePermission"
import { useTable } from "@/hook/useTable"

import { ICustomer } from "@/types/ICustomer"
import { FINANCE_KEY, FinanceOperationType, IFinance } from "@/types/IFinance"

import { documentDownload } from "@/utils/download"

export type FinanceTableProps = {
    onGetInvoice(order?: IFinance[]): void;
    customers?: ICustomer[]
}

export const FinanceTable = (props: FinanceTableProps) => {

    const pageCacheKey = FINANCE_KEY

    const { Error } = useMessage(pageCacheKey)

    const { hasPermission } = usePermission()

    const { filters } = useFinanceFilters()

    const { columns, pagination, filter, order } = useTable({
        initialColumns: financeColumns,
        key: pageCacheKey
    })

    const totalFilter = filter.filter

    const { data: orderData, isLoading: orderDataLoading } = useFinanceQuery({
        Page: pagination.page,
        PageSize: pagination.pageSize,
        Filter: totalFilter.replace(/, ,/g, ", "),
        OrderBy: order.orderBy
    })

    const customTableAction = hasPermission(Resource.Finance, Scope.Update) ?
        <ColorifiedButton
            themecolor="orange"
            icon={<AuditOutlined />}
            type={"primary"}
            onClick={() => props.onGetInvoice(orderData?.response.data)}
        >
            Получить счет
        </ColorifiedButton>
        :
        <></>

    useEffect(() => {
        if (columns.data.find(x => x.key == "documents") == undefined) {
            columns.data.push(
                {
                    title: "Документы",
                    key: "documents",
                    dataIndex: ["documents"],
                    width: 100,
                    isVisible: true,
                    order: 8,
                    render: (_: any, data) => {
                        return data.operationType !== FinanceOperationType.Cancelled &&
                            <Button type={"primary"} onClick={() => documentDownload(data, Error)}>Скачать</Button>
                    }
                })
        }

    }, [])

    return (
        <Spin spinning={orderDataLoading}>
            <Table
                tableTitle="Финансы"
                dataSource={orderData?.response.data}
                columns={columns.data}
                onUpdateColumns={columns.onColumnChange}
                customActions={customTableAction}
                filters={{
                    filters: filters,
                    onSubmit: filter.onFilterChange,
                    onCancel: filter.onFilterReset,
                    filterKey: pageCacheKey
                }}
                rowKey="id"
                isLoading={orderDataLoading}
                isSelectable={false}
                onSorterChange={order.setOrderBy}
                permission={{
                    resource: Resource.Finance
                }}
                pagination={{
                    currentPage: pagination.page,
                    pageSize: pagination.pageSize,
                    total: orderData?.response.count,
                    onPageChange: pagination.onPageChange,
                    onPageSizeChange: pagination.onPageSizeChange
                }}
            />
        </Spin>
    )
}
